import { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", phone: user?.phone || "" });
  const [kyc, setKyc] = useState({});
  const [emp, setEmp] = useState({});
  const [inc, setInc] = useState({});
  const [bank, setBank] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) setForm({ name: user.name || "", phone: user.phone || "" });
    api.get("/kyc").then((r) => setKyc(r.data || {})).catch(() => {});
    api.get("/employment").then((r) => setEmp(r.data || {})).catch(() => {});
    api.get("/income").then((r) => setInc(r.data || {})).catch(() => {});
    api.get("/bank").then((r) => setBank(r.data || {})).catch(() => {});
  }, [user]);

  const saveProfile = async () => {
    setSaving(true);
    try { await api.put("/profile", form); toast.success("Profile updated"); await refresh(); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6 max-w-4xl">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Profile</div>
          <h1 className="font-display text-3xl mt-2">Your account</h1>
        </div>
        <Card className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><Label>Full name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="profile-name" /></div>
            <div><Label>Email</Label><Input value={user?.email || ""} disabled /></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="profile-phone" /></div>
            <div><Label>KYC status</Label><Input value={user?.kyc_status || ""} disabled /></div>
          </div>
          <Button onClick={saveProfile} disabled={saving} className="mt-6 rounded-full brand-gradient text-white" data-testid="profile-save">{saving ? "Saving..." : "Save changes"}</Button>
        </Card>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <Card className="p-6"><div className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">KYC</div>{Object.keys(kyc).filter((k) => k !== "user_id").map((k) => <div key={k} className="flex justify-between text-sm"><span className="text-muted-foreground">{k}</span><span>{String(kyc[k] || "—")}</span></div>)}</Card>
          <Card className="p-6"><div className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">Employment</div>{Object.keys(emp).filter((k) => k !== "user_id").map((k) => <div key={k} className="flex justify-between text-sm"><span className="text-muted-foreground">{k}</span><span>{String(emp[k] || "—")}</span></div>)}</Card>
          <Card className="p-6"><div className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">Income</div>{Object.keys(inc).filter((k) => k !== "user_id").map((k) => <div key={k} className="flex justify-between text-sm"><span className="text-muted-foreground">{k}</span><span>{String(inc[k] || "—")}</span></div>)}</Card>
          <Card className="p-6"><div className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">Bank</div>{Object.keys(bank).filter((k) => k !== "user_id").map((k) => <div key={k} className="flex justify-between text-sm"><span className="text-muted-foreground">{k}</span><span>{String(bank[k] || "—")}</span></div>)}</Card>
        </div>
      </div>
    </DashboardLayout>
  );
}
